export const STATUS_EXERCISE = [
  { label: 'Not Started', value: null },
  { label: 'In Progress', value: 'inprogress' },
  { label: 'No Show', value: 'noshow' },
  { label: 'Done', value: 'done' },
];

export const STATUS_MILESTONE = [
  { label: 'Not Started', value: null },
  { label: 'In Progress', value: 'inprogress' },
  { label: 'Done', value: 'done' },
];
